import { createFileRoute } from '@tanstack/react-router';

import { assertPermissionOrRedirect, Permission } from '@auth/data-access';
import { ValidationFormDetailsPage } from '@contracts';

export const Route = createFileRoute(
  '/_app/os/validation-forms_/$validationFormId',
)({
  beforeLoad(ctx) {
    assertPermissionOrRedirect(ctx.context.auth, Permission.ValidationForms);
  },
  component: ValidationFormDetailsPage,
  pendingComponent: ValidationFormDetailsPage.Skeleton,
  errorComponent: ValidationFormDetailsPage.Error,
});
